export default "/images/close-icon.png?9842be203ddeac840d8e1a49759f329f";